import { memo } from "react";

// Circle sized to match one circle of the Show Overlap icon beside it
// (mdiSetNone: ring r=5 to r=7, so centreline r=6 at thickness 2).
function NonProducingWell_Icon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="6" stroke="currentColor" strokeWidth="2" />
      <line
        x1="4.6"
        y1="19.4"
        x2="19.4"
        y2="4.6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default memo(NonProducingWell_Icon);
